import React, { useState } from "react";
import { Icon } from "@iconify/react";
import "./Tools.css";


const menuItems = [
  { title: "Merge PDF", icon: "mdi:file-plus", url: "https://www.spcommunity.org.za/merge-pdf/" },
  { title: "Split PDF", icon: "mdi:split-horizontal", url: "https://www.spcommunity.org.za/split-pdf/" },
/*  { title: "Compress PDF", icon: "mdi:arrow-collapse-all", url: "https://www.spcommunity.org.za/compress-pdf" }, 
  { title: "Resume Score", icon: "mdi:chart-bell-curve", url: "https://www.spcommunity.org.za/cv-resume-analysis/" }, */
];


const Tools = () => {
  const [activeUrl, setActiveUrl] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  return (
    <div className="extras-page">
      {/* Fixed Back Button */}
      {activeUrl && (
        <div className="fixed-back-button" onClick={() => setActiveUrl(null)}>
          <Icon icon="mdi:arrow-left" width="24" height="24" />
          <span>Back</span>
        </div>
      )}

      {/* Menu */}
      {!activeUrl && (
        <div className="extras-menu-container">
          {menuItems.map((item, idx) => (
            <div
              key={idx}
              className="menu-item"
              onClick={() => {
                setPopupMessage("Tools are currently unavailable, please access them on the website spcommunity.org.za/tools");
                setShowPopup(true);
              }}
            >
              <div className="menu-icon-wrapper">
                <Icon
                  icon={item.icon}
                  width="36"
                  height="36"
                  className="menu-icon"
                />
              </div>
              <span className="menu-title">{item.title}</span>
            </div>
          ))}
        </div>
      )}

      {/* Popup */}
      {showPopup && (
    <div className="custom-popup">
      <div className="popup-content">
        <p>{popupMessage}</p>
        <button onClick={() => setShowPopup(false)}>OK</button>
      </div>
    </div>
  )}

      {/* Iframe (disabled, no longer shown since tools unavailable) */}
      {/* {activeUrl && (
        <iframe
          src={activeUrl}
          title="Extras Content"
          className="extras-iframe"
        ></iframe>
      )} */}
    </div>
  );
};

export default Tools;


/*
const Tools = () => {
  const [activeUrl, setActiveUrl] = useState(null);
  

  return (
    <div className="extras-page">
  
      {activeUrl && (
        <div className="fixed-back-button" onClick={() => setActiveUrl(null)}>
          <Icon icon="mdi:arrow-left" width="24" height="24" />
          <span>Back</span>
        </div>
      )}

     
      {!activeUrl && (
        <div className="extras-menu-container">
          {menuItems.map((item, idx) => (
            <div
              key={idx}
              className="menu-item"
             
              onClick={() => setActiveUrl(item.url)} 
            >
              <div className="menu-icon-wrapper">
                <Icon icon={item.icon} width="36" height="36" className="menu-icon" />
              </div>
              <span className="menu-title">{item.title}</span>
            </div>
          ))}
        </div>
      )}

    
      {activeUrl && (
        <iframe
          src={activeUrl}
          title="Extras Content"
          className="extras-iframe"
        ></iframe>
      )}
    </div>
  );
};

export default Tools;
*/